import { css } from 'lit';

export const timeredCounterStringStyles = css``;
